import React from 'react';
import { PageLayout } from '@/shared/layout/PageLayout';
import { RequestsKpiDashboard } from './components/RequestsKpiDashboard';
import { RequestsModulesGrid } from './components/RequestsModulesGrid';
import { RecentRequestActivity } from './components/RecentRequestActivity';

export function RequestsPage() {
  return (
    <PageLayout
      title="Yêu cầu & Đề xuất"
      description="Trung tâm khởi tạo, theo dõi và quản lý mọi yêu cầu cấp phát vật tư, nhân sự và thiết bị"
    >
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">

        {/* Top KPIs Dashboard */}
        <RequestsKpiDashboard />

        {/* Navigation Hub */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-blue-500 rounded-full" />
                Các Loại Đề Xuất (Request Types)
              </h3>
            </div>
            <div className="flex-1">
              <RequestsModulesGrid />
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-amber-500 rounded-full" />
                Hoạt động gần đây
              </h3>
              <button className="text-xs font-medium text-blue-600 hover:text-blue-700 hover:underline transition-colors cursor-pointer">
                Xem toàn bộ &rarr;
              </button>
            </div>
            <div className="flex-[2] flex flex-col min-h-0">
              <RecentRequestActivity />
            </div>

          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default RequestsPage;
